import CapturedColorIQBox from 'components/ShadeFinder/ResultsScreen/CapturedColorIQBox/CapturedColorIQBox';
import { withCapturedColorIQBoxProps } from 'viewModel/shadeFinder/resultsScreen/capturedColorIQBox/withCapturedColorIQBoxProps';

export default withCapturedColorIQBoxProps(CapturedColorIQBox);
